import { Class } from "types";
import { api } from "../api";
import { NetworkError } from "../networkError";

interface Params {
  token: string;
  classId: string;
  className: string;
}

const updateClass = async ({ token, classId, className }: Params): Promise<Class> => {
  const response = await api.put(
    `/classes/${classId}`,
    {
      name: className,
    },
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  const newClass = response.data;

  if (newClass) {
    return newClass;
  } else {
    throw new NetworkError();
  }
};

export { updateClass };
